import { render, staticRenderFns } from "./index-active.vue?vue&type=template&id=42fc1ec4&scoped=true&"
import script from "./index-active.vue?vue&type=script&lang=js&"
export * from "./index-active.vue?vue&type=script&lang=js&"
import style0 from "./index-active.vue?vue&type=style&index=0&id=42fc1ec4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fc1ec4",
  null
  
)

export default component.exports